// NAK Chart
// Need    Angle      Known
// ------------------------------------
// Hyp  =  csc(A)  x  Opp [ Cosecant ]
// Hyp  =  sec(A)  x  Adj [ Secant ]
// Opp  =  tan(A)  x  Adj [ Tangent ]
// Opp  =  sin(A)  x  Hyp [ Sine ]
// Adj  =  cos(A)  x  Hyp [ Cosine ]
// Adj  =  cot(A)  x  Opp [ Cotangent ]
// ------------------------------------

let secant = (angle) => 1 / Math.cos(angle);

let deg2rad =(degree) => degree * Math.PI / 180;

let calculateSlope = (width, angle) => Math.floor(Math.tan(deg2rad(angle)) * width);

function slanter() {

  let slantBottoms = document.getElementsByClassName('service-button');
  // for (var slantBottom of slantBottoms) {
  //   Sigh, Edge / IE
  // }

  [].forEach.call(slantBottoms, function(slantBottom) {
    let computedStyles = slantBottom.getBoundingClientRect();
    let elementWidth = computedStyles.width;

    if (document.styleSheets[0].addRule) {
      document.styleSheets[0].addRule(
        '.service-button:after',
        'border-bottom: '
        +  calculateSlope(elementWidth, 3)
        + 'px solid #fff;'
        + 'border-left: '
        + elementWidth
        + 'px solid transparent;'
      );
    } else {
      document.styleSheets[0].insertRule(
        '.service-button:after {border-bottom: '
        +  calculateSlope(elementWidth, 3)
        + 'px solid #fff;'
        + 'border-left: '
        + elementWidth
        + 'px solid transparent;}', 0
      )
    }
  });

}
slanter();
window.onresize = slanter;
